import { useCappedList } from "@/hooks/useCappedList";
import { FilterOptions } from "@/types/FilterOptions";
import { SearchFilterV4 } from "@/types/SearchFilter";
import { Button } from "@components/ui/button";
import PageChannelNames from "@components/SearchFilter/partials/PageChannelNames";
import { ButtonGroup } from "@components/ui/button-group";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@components/ui/popover";
import {
  Command,
  CommandInput,
  CommandList,
  CommandEmpty,
} from "@components/ui/command";
import { XIcon, UserCircleIcon } from "lucide-react";
import { Trans, useLingui } from "@lingui/react/macro";

export default function ChannelNames({
  options,
  onChange,
  value,
}: {
  onChange?: (value: SearchFilterV4, clear?: boolean) => void;
  value: SearchFilterV4["channel_name"];
  options: FilterOptions["filter_channels"];
}) {
  const { t } = useLingui();

  // Helpers
  const formatCappedList = useCappedList();
  const isArray = Array.isArray(value);
  const valueLabel = value
    ? isArray
      ? formatCappedList(value, {
          cap: 1,
          maxStringLength: 20,
        })
      : value
    : "N/A";

  return (
    <ButtonGroup>
      <Button
        size="xs"
        render={<div />}
        variant={onChange ? "outline" : "secondary"}
        className="pointer-events-none"
      >
        <UserCircleIcon />
        <Trans>Källa</Trans>
      </Button>
      <Button
        size="xs"
        render={<div />}
        variant={onChange ? "outline-muted" : "secondary"}
        className="pointer-events-none"
      >
        {isArray && value.length > 1 ? (
          <Trans>är någon av</Trans>
        ) : (
          <Trans>är</Trans>
        )}
      </Button>
      {onChange ? (
        <Popover>
          <PopoverTrigger render={<Button size="xs" variant="outline" />}>
            {valueLabel}
          </PopoverTrigger>
          <PopoverContent align="start" className="w-80 p-0">
            <Command>
              <CommandInput placeholder={t`Källor`} />
              <CommandList>
                <CommandEmpty>
                  <Trans>Inga filter hittades</Trans>
                </CommandEmpty>
                <PageChannelNames
                  value={value}
                  onChange={onChange}
                  options={options}
                />
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
      ) : (
        <Button
          size="xs"
          render={<div />}
          variant="secondary"
          className="pointer-events-none"
        >
          {valueLabel}
        </Button>
      )}
      {onChange && (
        <Button
          size="icon-xs"
          variant="outline"
          type="button"
          onClick={() => {
            onChange({
              channel_name: undefined,
            });
          }}
        >
          <XIcon />
          <span className="sr-only">
            <Trans>Ta bort filter</Trans>
          </span>
        </Button>
      )}
    </ButtonGroup>
  );
}
